import useAnimationThemeSelector from '@/components/global/ThemeSelector.animation'
import {usePageContext}          from '@/context/PageContext'
import Moon_SVG                  from '@/svg/Moon_SVG'
import Sun_SVG                   from '@/svg/Sun_SVG'
import cn                        from 'classnames'
import {useRef}                  from 'react'
import styles                    from './ThemeSelector.module.sass'

interface ThemeAriaLabels {
	darkModeAriaLabel: string;
	lightModeAriaLabel: string;
}

type Props = {
	dataThemes?: ThemeAriaLabels
}

export default function ThemeSelector({dataThemes}: Props) {
	const containerRef = useRef<HTMLButtonElement>(null)
	const overlayRef   = useRef<HTMLDivElement>(null)
	const {
		      activeTheme,
		      setActiveTheme,
	      }            = usePageContext()

	useAnimationThemeSelector({
		containerRef,
		overlayRef,
	})

	return (<button
		type={'button'}
		className={styles.theme}
		ref={containerRef}
		onClick={() => {
			switchTheme(activeTheme, setActiveTheme)
		}}
		data-cursor-pointer
		aria-label={'dark' === activeTheme ? dataThemes?.lightModeAriaLabel : dataThemes?.darkModeAriaLabel}
	>
		<Sun_SVG className={cn(styles.theme__icon, {[styles.theme__active]: activeTheme === 'light'})}/>
		<Moon_SVG className={cn(styles.theme__icon, {[styles.theme__active]: activeTheme === 'dark'})}/>

		{/* Active overlay */}
		<div
			ref={overlayRef}
			className={styles.theme__active_overlay}
		/>
	</button>)
}

const switchTheme = (activeTheme: 'dark' | 'light', setActiveTheme: (theme: 'dark' | 'light') => void) => {
	setActiveTheme('dark' === activeTheme ? 'light' : 'dark')
}
